import { render, staticRenderFns } from "./discussions_badge.vue?vue&type=template&id=2f8268d8"
import script from "./discussions_badge.vue?vue&type=script&lang=js"
export * from "./discussions_badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports